import { useQuery } from '@tanstack/react-query';
import { fetchAvailablePermissions } from '../services/userRbac';
import type { AvailablePermission } from '../types/users.types';

export const availablePermissionKeys = {
    all: ['users', 'available-permissions'] as const,
    lists: () => [...availablePermissionKeys.all, 'list'] as const,
};

export const useAvailablePermissionsQuery = () => {
    return useQuery<AvailablePermission[]>({
        queryKey: availablePermissionKeys.lists(),
        queryFn: fetchAvailablePermissions,
        staleTime: 10 * 60 * 1000,
        gcTime: 30 * 60 * 1000,
    });
};
